var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { locked: _vm.token === null } },
    [
      _c("ul", { staticClass: "title-nav" }, [
        _c(
          "li",
          {
            on: {
              click: function($event) {
                return _vm.handleBack()
              }
            }
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "title-label" }, [
              _c("i", { staticClass: "material-icons md-18" }, [
                _vm._v(_vm._s(_vm.getCategoryIcon(_vm.category)))
              ]),
              _vm._v(
                " " +
                  _vm._s(_vm.category.toUpperCase()) +
                  " (" +
                  _vm._s(_vm.overlays.length) +
                  ")"
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.token === null
        ? _c(
            "div",
            { staticClass: "lock-block", on: { click: _vm.routeLogin } },
            [_vm._m(1), _vm._v(" "), _vm._m(2)]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.overlays.length === 0
        ? _c("div", { staticClass: "section-title text-center" }, [
            _vm._v(
              "\n\t\tNo " +
                _vm._s(_vm.category) +
                " overlays for this parcel\n\t"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.overlays, function(source, index) {
        return _c("div", { staticClass: "section" }, [
          _c("div", { staticClass: "section-title property-locked" }, [
            _c("span", [
              _c(
                "span",
                {
                  staticClass: "link",
                  on: {
                    click: function($event) {
                      return _vm.routeOverlay(source.features[0])
                    }
                  }
                },
                [_vm._v(_vm._s(source.name))]
              ),
              _vm._v(" "),
              _vm.deviceType !== "mobile"
                ? _c(
                    "a",
                    {
                      staticClass: "visible-icon float-right",
                      class: {
                        active: _vm.overlaysVisible[_vm.overlayKey(source)]
                      },
                      attrs: { href: "javascript:" },
                      on: {
                        click: function($event) {
                          return _vm.overlayLayerToggle(source)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "material-icons md-18" }, [
                        _vm._v("visibility")
                      ])
                    ]
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "section-body" },
            [
              _c("div", { staticClass: "category" }, [
                _c("div", { staticClass: "category-title" }, [
                  _vm._v("DESCRIPTION")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "property-row" }, [
                  _c("div", { staticClass: "text-break property-locked" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(
                          source.description || "No description available"
                        ) +
                        "\n\t\t\t\t\t"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._l(source.features, function(overlay, index) {
                return _c("div", { staticClass: "feature" }, [
                  overlay.details
                    ? _c(
                        "div",
                        { staticClass: "category" },
                        [
                          _c("div", { staticClass: "category-title" }, [
                            _vm._v("\n\t\t\t\t\t\tDETAILS \n\t\t\t\t\t\t"),
                            source.features.length > 1
                              ? _c("span", [
                                  _vm._v("(" + _vm._s(index + 1) + ")")
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _vm._l(overlay.details, function(detail, index) {
                            return _c("div", { staticClass: "property-row" }, [
                              _c("label", [_vm._v(_vm._s(detail.name))]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "property-value-right property-locked"
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(detail.value) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ])
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isReference(overlay)
                    ? _c(
                        "div",
                        { staticClass: "category" },
                        [
                          _c("div", { staticClass: "category-title" }, [
                            _vm._v("\n\t\t\t\t\t\tREFERENCES \n\t\t\t\t\t\t"),
                            source.features.length > 1
                              ? _c("span", [
                                  _vm._v("(" + _vm._s(index + 1) + ")")
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _vm._l(overlay.references, function(ref, idx) {
                            return _c("div", { staticClass: "property-row" }, [
                              _c("label", [_vm._v(_vm._s(ref.description))]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "property-value-right" },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: ref.url, target: "_blank" }
                                    },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons md-12" },
                                        [_vm._v("open_in_new")]
                                      ),
                                      _vm._v(" Link")
                                    ]
                                  )
                                ]
                              )
                            ])
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ])
              }),
              _vm._v(" "),
              _vm.token === null
                ? _c(
                    "div",
                    {
                      staticClass: "over-action d-flex",
                      on: { click: _vm.routeLogin }
                    },
                    [_vm._m(3, true)]
                  )
                : _vm._e()
            ],
            2
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "back-btn" }, [
      _c("i", { staticClass: "material-icons md-18" }, [
        _vm._v("keyboard_arrow_left")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lock-icon-box" }, [
      _c("i", { staticClass: "material-icons md-36" }, [_vm._v("account_box")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lock-text" }, [
      _c("h5", { staticClass: "mb-0 text-white" }, [
        _vm._v("Sign in to view overlays")
      ]),
      _vm._v(" "),
      _c("h5", { staticClass: "mb-0 font-weight-light text-light" }, [
        _vm._v("Get details on parcel capabilities")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "over-action-box align-self-center text-white hover-dk" },
      [
        _c("div", { staticClass: "text-center" }, [
          _c("i", { staticClass: "material-icons text-light md-36" }, [
            _vm._v("account_box")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-center" }, [
          _vm._v("\n\t\t\t\t\t\tSign in to view\n\t\t\t\t\t")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e208ef1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e208ef1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parcel/parcel-overlays.vue
// module id = null
// module chunks = 